import CommonUtils from "@bodeboca/utils"
import ApiService from "@bodeboca/api"
import InsightsUtils from "../../../../bb_algolia/js/src/utils/insights";

(function (Drupal, drupalSettings, jQuery) {
  Drupal.behaviors.ucAjaxCart = {
    attach: function (context, settings) {
      // add to cart quantity adjust
      jQuery(once(".qty-processed", ".form-item-qty", context)).change(
        function () {
          addToCartChangeValue(jQuery(this).attr("data-nid"), 0)
        },
      )
      jQuery(once("qty-processed", ".add-to-cart .plus", context)).click(
        function () {
          addToCartChangeValue(jQuery(this).attr("data-nid"), 1)
        },
      )
      jQuery(once("qty-processed", ".add-to-cart .minus", context)).click(
        function () {
          addToCartChangeValue(jQuery(this).attr("data-nid"), -1)
        },
      )

      jQuery("#uc-cart-view-form select, #uc-cart-view-form input", context)
        .not(".disablediscount")
        .removeAttr("disabled")

      // Add to cart form
      jQuery(
        once(
          ".ajax-cart-processed",
          "form.ajax-cart-submit-form input.ajax-cart-submit-form-button",
          context,
        ),
      )
        .not("#edit-update")
        .click(function (e) {
          CommonUtils.setIsLoading(true)
          const nid = jQuery(this).attr("data-nid")
          const qty = jQuery(".quantity[data-nid=" + nid + "]").val()
          if (qty == 0) {
            CommonUtils.showBbAjaxMessage(
              drupalSettings.bb_ajax_cart.ZERO_QTY_ADD_TO_CART_MSG,
              "error",
            )
            return false
          }

          drupalSettings.bb_ajax_cart.has_cart = true

          jQuery(".cart-block, .mobile-menu-bar .cart-menu-wrapper")
            .removeClass("full")
            .addClass("empty")

          const form = jQuery(this).parents("form").eq(0)

          const product_title = jQuery(
            'input[name="product-title"]', 
            form
          ).val()

          let queryId = InsightsUtils.getQueryId(nid)
          ApiService.addToCart(nid, qty, product_title, queryId)

          e.preventDefault()
          return false
        })
    },
  }
})(Drupal, drupalSettings, jQuery)

function addToCartChangeValue(nid, val) {
  // Calculate info we need
  const element = jQuery(".quantity[data-nid=" + nid + "]")
  const max = parseInt(element.attr("max"))
  const current = parseInt(element.val())
  val = parseInt(val)

  let newval = current + val

  if (newval < 1) {
    newval = 1
  }

  if (newval > max) {
    newval = max
    const error = drupalSettings.bb_ajax_cart.NOT_ENOUGH_STOCK_MSG
    CommonUtils.showBbAjaxMessage(error, "error")
  }

  element.val(newval)
}
